.wrapper{overflow-x:auto}.context-row{display:grid;grid-auto-flow:column;gap:4px;word-wrap:break-word;width:max-content}.sticky{position:sticky;left:0;align-content:center;background-color:#e9e9e9;padding:8px}.cell-value{border:1px solid #e9e9e9;padding:8px}
/*# sourceMappingURL=read-only-table.component.css.map */
